



































































import { Component, Mixins, Prop } from "vue-property-decorator";

import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome";
import { library } from "@fortawesome/fontawesome-svg-core";
import { faSpinner } from "@fortawesome/free-solid-svg-icons";

library.add(faSpinner);

import InputCurrency from "@/components/input/InputCurrency.vue";
import ModalBase from "@/components/modal/ModalBase.vue";

import { ACTIONS } from "@/event-bus";

import { toBN } from "@/lib/web3x-es/utils";
import { Address } from "@/lib/web3x-es/address";

import CurrencyMixin from "@/mixins/currency";
import BN from "bn.js";

@Component({
  components: {
    FontAwesomeIcon,
    InputCurrency,
    ModalBase,
  },
})
export default class ModalStake extends Mixins(CurrencyMixin) {
  @Prop(String) private action!: string;
  @Prop(String) private description!: string;
  @Prop(String) private address!: string;
  @Prop(String) private walletBalance!: string;
  @Prop(String) private totalStaked!: string;
  @Prop(Boolean) private showSpinner!: boolean;

  private paymentAmount: BN = toBN("0");
  private destinationAddress = "";

  get validatedAddress() {
    if (this.destinationAddress === "") {
      return true;
    }
    return Address.isAddress(this.destinationAddress);
  }

  get maxAmount() {
    return this.action === "unstake" ? this.totalStaked : this.walletBalance;
  }

  private async updateValue(newValue: BN) {
    this.paymentAmount = newValue;
  }

  private tryCloseModal() {
    this.$emit(ACTIONS.CLOSE);
  }

  private stake() {
    this.$emit("stake", this.paymentAmount);
  }

  private unstake() {
    this.$emit("unstake", this.paymentAmount);
  }
}
